<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-user-clock', fontSet: 'fad'}"
	[headerText]="'Student Portal Session Replication'"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
	[showActionDivider]="false"
>
	<ng-container dialogContent>
		<label>Accessible From</label>
		<mat-form-field class="w-100" color="accent">
			<mat-label>Date</mat-label>
			<input
				(click)="datepickerFrom.open()"
				[formControl]="formGroup.controls.accessibleFromDate"
				[matDatepicker]="datepickerFrom"
				matInput
				readonly
			/>
			@if (formGroup.controls.accessibleFromDate.hasError("required")) {
				<mat-error>Date invalid</mat-error>
			}
			<mat-datepicker-toggle [for]="datepickerFrom" matIconSuffix>
				<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fa" matDatepickerToggleIcon />
			</mat-datepicker-toggle>
			<mat-datepicker #datepickerFrom />
		</mat-form-field>

		<!--TIME-->
		<sim-clock-time-input [formCtrl]="formGroup.controls.accessibleFromTime" [labelKey]="'Time'" />

		<label class="w-100">Accessible Until</label>
		<mat-form-field color="accent">
			<mat-label>Date</mat-label>
			<input
				(click)="datepickerUntil.open()"
				[formControl]="formGroup.controls.accessibleUntilDate"
				[matDatepicker]="datepickerUntil"
				matInput
				readonly
			/>
			@if (formGroup.controls.accessibleUntilDate.hasError("required")) {
				<mat-error>Date invalid</mat-error>
			}
			<mat-datepicker-toggle [for]="datepickerUntil" matIconSuffix>
				<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fa" matDatepickerToggleIcon />
			</mat-datepicker-toggle>
			<mat-datepicker #datepickerUntil />
		</mat-form-field>

		<!--TIME-->
		<sim-clock-time-input [formCtrl]="formGroup.controls.accessibleUntilTime" [labelKey]="'Time'" />
	</ng-container>
	<ng-container actions>
		<button mat-raised-button color="warn" (click)="close()">
			{{ T.BUTTON_CLOSE | translate }}
		</button>

		<button mat-raised-button color="accent" (click)="triggerReplication()">Trigger Replication</button>
		<button mat-raised-button color="accent" (click)="updateSessionAccess()" [disabled]="formGroup.invalid">Update</button>
	</ng-container>
</sim-basic-material-dialog>
